import { render, staticRenderFns } from "./DishesContainer.vue?vue&type=template&id=32ba14a0&scoped=true&"
import script from "./DishesContainer.vue?vue&type=script&lang=js&"
export * from "./DishesContainer.vue?vue&type=script&lang=js&"
import style0 from "./DishesContainer.vue?vue&type=style&index=0&id=32ba14a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba14a0",
  null
  
)

component.options.__file = "DishesContainer.vue"
export default component.exports